import {
  DC_CANCELAR_START,
  DC_GUARDAR_START,
  DC_SOLICITAR_START,
  DC_GETLISTADO_START,
} from "../../const/actionTypes";

export const GetDias = (payload) => ({
  type: DC_GETLISTADO_START,
  payload,
});
export const Solicitar = (payload) => ({
  type: DC_SOLICITAR_START,
  payload,
});
export const Guardar = (payload) => ({
  type: DC_GUARDAR_START,
  payload,
});
export const Cancelar = (payload) => ({
  type: DC_CANCELAR_START,
  payload,
});
